<div class="eve2-success-header">
  <app-ds-rounded-icon variant="success" icon="party-popper" size="large"></app-ds-rounded-icon>
  <h1 class="ds-heading-1">{{ 'EVE2.de.consentSuccess.header.title' | translate }}</h1>
  <p class="ds-color-core-neutral-8">{{ 'EVE2.de.consentSuccess.header.description' | translate }}</p>
</div>

<div class="eve2-success-steps">
  <h2 class="ds-heading-2">{{ 'EVE2.de.consentSuccess.steps.title' | translate }}</h2>
  <ul>
    <li>
      <app-ds-rounded-icon variant="info" icon="mail"></app-ds-rounded-icon>
      <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'EVE2.de.consentSuccess.steps.step1' | translate }}</p>
    </li>
    <li>
      <app-ds-rounded-icon variant="info" icon="circle-check-big"></app-ds-rounded-icon>
      <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'EVE2.de.consentSuccess.steps.step3' | translate }}</p></li
    >
  </ul>
</div>

<div class="eve2-success-actions">
  <app-ds-button width="full" (clicked)="closeModal.emit()">{{ 'EVE2.de.consentSuccess.actions.return' | translate }}</app-ds-button>
</div>
